// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wdBH","fullView":"styles_fullView__1uny2"};